import React, { Component } from "react";
import "./main.scss";
import * as api from "./../api";
import formatTime from "./../utils/formatTime";
import Slide from "./slide";
import MyAward from './myAward';
import ActivityTime from './activityTime';
import kFormat from './../utils/kFormat';
import { Link } from 'react-router-dom';
import Detector from './../utils/detector';
import ShareTipDialog from '../popup/shareTipDialog';
import EndedDialog from './../popup/endedDialog';
import ErrorDialog from './../popup/errorDialog';

const isJrApp = !!navigator.userAgent.toLowerCase().match(/jdjr-app/i);
export default class MainPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shareInfoRes: {},
      timeInfo: {
        name: "",
        calcTime: '',
        beginTime: '',
        endTime: '',
        nextTime: ''
      },
      joinInfo: {
        isJoin: '0',
        totalUser: '0',
        awardList: [],
        status: ''
      },
      statusBtnDom: null,
      myAwardDom: null,
      activityTimeDom: null,
      // 分享功能信息
      shareInfo: {
        btnText: '',
        shareIcon: '',
        shareTitle: '',
        shareSummary: '',
        shareLink: ''
      },
      // 是否已预约或已分享
      finishedInfo: {
        reminded: '',
        shared: ''
      },
      activityTimeInfo: {},
      wxShareTipDom: null,
      endedTipDom: null,
      errorTipDom: null,
      isShareSuccess: -1 // 分享成功
    };

    this.data_source = window.data_source_100001226;
  }

  componentWillMount () {
    this._judgeIsShareRemind()
    window.$('canvas').css('display', 'none')
  }
  
  _loadShareInfo(){
    let param = {
      actCode: Detector.interface_ActCode
    }
    api.myShareInfo({reqData: JSON.stringify(param)}).then(res => {
      if (res.resultCode === -1) {// 接口异常时提示弹窗
        this._showErrorTipDialog()
        return
      }
      let { code, data } = res.resultData
      console.log('myShareInfo_resultData:::', res.resultData)
      if (code === '00000hby') {
        let timerObj = data.nextornow
        let info = Object.assign({}, this.state.joinInfo, {
          isJoin: data.isjoin, // 当前时间段最多参与2次  分享+1次
          totalUser: data.joinUserNum,
          awardList: data.awardList,
          status: timerObj.result
        });
        sessionStorage.setItem('yqs_sharedTimes', data.isjoin)
        sessionStorage.setItem('yqs_isNowTime', timerObj.result)
        this._renderStatusBtn(info)
        let slideObj = data.ridingLantern
        // console.log('data.ridingLantern:::', data.ridingLantern)
        const slideArr = slideObj.map((t) => { 
          return {
            text: t
          }
        });
        this._judgeActivityStatus(timerObj);
        this.setState({ shareInfoRes: data, joinInfo: info, slideInfo: slideArr});
        this._renderMyAward(data.myRewardList)
      }
    })
  }

  _judgeActivityStatus(obj) {
    // result为now 活动正在进行  result为next 距离下一场  result为nonext 活动已截止
    let nowTime = +new Date();
    let timeDiff = ''
    let diffTimeStr = '';
    let timerVal = null
    if (obj.result === 'now') {
      timeDiff = obj.endTime - nowTime;
      diffTimeStr = formatTime(timeDiff)
      timerVal = Object.assign({}, this.state.timeInfo, {
        name: "距离结束",
        calcTime: obj.endTime,
        beginTime: obj.beginTime,
        endTime: obj.endTime,
        nextTime: obj.nextTime
      });
    } else if (obj.result === 'next') {
      timeDiff = obj.beginTime - nowTime;
      diffTimeStr = formatTime(timeDiff);
        timerVal = Object.assign({}, this.state.timeInfo, {
          name: "距离开抢",
          calcTime: obj.beginTime,
          beginTime: obj.beginTime,
          endTime: obj.endTime,
          nextTime: obj.nextTime
        });
    } else if (obj.result === 'noNext') {
      this._showEndedTipDialog() // 活动结束弹窗
      timerVal = Object.assign({}, this.state.timeInfo, {
        name: "暂无下一场活动",
        calcTime: obj.beginTime,
        beginTime: obj.beginTime,
        endTime: obj.endTime,
        nextTime: obj.nextTime
      });
    }
    this.setState({ timeInfo: timerVal });
    this._renderActivityTime(obj.result, timerVal)
    console.log('diffTimeStr:::', diffTimeStr)
  }

  getConfigContents(str) {
    let info = this.data_source.activity.options;
    this._loadShareInfo(str)
    let shareInfo = Object.assign({}, {
      btnText: str === 'yes' ? info.share_btn_text2 : info.share_btn_text,
      shareIcon: info.share_icon_url,
      shareTitle: info.share_title,
      shareSummary: info.share_summary,
      shareLink: info.share_link
    })
    let timeInfo = Object.assign({}, {
      dateStr: info.begin_date + '-' + info.end_date,
      dateRangeTip: info.date_range_tip,
      timeSlots: Object.values(info.time_slot_list.options)
    })
    this.setState({shareInfo: shareInfo, activityTimeInfo: timeInfo})
  }
  
  // 记录分享操作
  _setIsShared() {
    let param = {
      actCode: Detector.interface_ActCode,
      wxNickName: 'yes'
    }
    api.isFinishedInfo({reqData: JSON.stringify(param)}).then(res => {
      let { code, data } = res.resultData
      if (code === '00000hby') {
        let info = Object.assign({}, this.state.finishedInfo, {
          reminded: data.tixing,
          shared: data.weixin
        })
        this._judgeIsShareRemind()
        this.setState({finishedInfo: info, statusBtnDom: (<div className="btnRemind enable"><Link to='/' className='link' clstag="jr|keycount|yqsbhby|16" onClick={this._handleJoinGame.bind(this)}>点击参与</Link></div>)})
      }
    })
  }
  
  // 关闭弹窗
  _handleCloseCallback(obj) {
    console.log('关闭弹窗回调:::')
    this.setState({wxShareTipDom: null, endedTipDom: null})
  }

  _showShareTipDialog() {
    this.setState({wxShareTipDom: <ShareTipDialog closeCallback={(obj) => this._handleCloseCallback(obj)}/>})
  }

  _showEndedTipDialog() {
    this.setState({endedTipDom: <EndedDialog closeCallback={(obj) => this._handleCloseCallback(obj)}/>})
  }

  _showErrorTipDialog() {
    this.setState({errorTipDom: <ErrorDialog closeCallback={(obj) => this._handleCloseCallback(obj)}/>})
  }

  _handleShare() {
    const info = window.data_source_100001226.activity.options;
    let shareMain = {img: `${info.share_icon_url}`, title: `${info.share_title}`, desc: `${info.share_summary}`}
    //channels: 0-微信朋友圈，1-微信好友
    let shareUrl = [
      {channels:'0',url: `${info.share_link}`},
      {channels:'1',url: `${info.share_link}`},
    ]
    window.GlobalShare.share(shareMain, shareUrl)
    // this._loadShareInfo('yes')
    let defer = window.jsBridgeV3.onReady()
    if (isJrApp) {
      try {
        defer.then(function(res) {
          this.jsToGetResp(function(d) {
            d = typeof d == 'object' ? d : window.$.parseJSON(d);
            let shareState = parseInt(d.share.shareState);
            // alert('shareState:::', shareState) // 空值
            if(shareState == 2 || shareState == 3){
              // self._showShareTipDialog();
            }
          })
        })
      } catch (error) {
        console.log('error:::', error)
      }
    }
    setTimeout(() => {
      if (parseInt(sessionStorage.getItem('yqs_sharedTimes')) < 2 && sessionStorage.getItem('yqs_isNowTime')==='now') {
        this._shareAddTimes.call(this)
        this._showShareTipDialog.call(this)
      }
    }, 3000)
  }

  _shareAddTimes() {
    let param = {
      actCode: Detector.interface_ActCode
    };
    api.addTimes({ reqData: JSON.stringify(param) }).then(res => {
      let { code } = res.resultData
      if (code === '00000hby') {
        this._setIsShared.call(this)
      }
    });
  }
  
  // 记录设置提醒操作
  _setIsRemind() {
    let param = {
      actCode: Detector.interface_ActCode,
      code: 'yes'
    }
    api.isFinishedInfo({reqData: JSON.stringify(param)}).then(res => {
      let { code, data } = res.resultData
      if (code === '00000hby') {
        let info = Object.assign({}, this.state.finishedInfo, {
          reminded: data.tixing,
          shared: data.weixin
        })
        this._judgeIsShareRemind()
        console.log('_setIsRemind__success:::')
        this.setState({finishedInfo: info, statusBtnDom: <div className="btnRemind disable" clstag="jr|keycount|yqsbhby|15">已预约</div>})
      }
    })
  }

  _handleRemindMe() {
    let { beginTime, endTime, nextTime } = this.state.timeInfo
    // 站外执行唤起操作
    if (!isJrApp) {
      window.location.href = `https://m.jr.jd.com/spe/downloadApp/index.html?id=1192&activityid=1158`
      return
    }
    let self = this, beginTimeStr = '', endTimeStr = ''
    //返回noNext  活动已结束 没有下一场
    if (typeof nextTime === 'number') {
      // 提前5分钟提醒
      beginTimeStr = nextTime - 300000
      endTimeStr = nextTime + 300000
    } else {
      beginTimeStr = beginTime
      endTimeStr = endTime
    }
    let defer = window.jsBridgeV3.onReady()
    if (isJrApp) {
      try {
        defer.then(function(res) {
          res.jsToGetResp(function(d) {
            if (d.success === 0) {
              console.log('success')
            } else if (d.success === 1) {
              console.log('failed')
            }
          }, {
            "type": 36,
            "identifier": "摇钱树活动提醒：5分钟后别忘了抢红包" + (+new Date()), //事件唯一标示 （必须）
            "title": "摇钱树活动提醒：5分钟后别忘了抢红包~", //事件名称（必须）
            "startDate": beginTimeStr, //开始时间 标准的时间戳
            "endDate": endTimeStr,   //结束时间 标准的时间戳
            "allDay": "",   //是否是全天 （bool，非必须，默认为NO）
            "backUrl": "https://m.jr.jd.com/activity/yqshby2018/#/main"   //拓展url（非必须）
          })
        });
      } catch (error) {
        console.log('remind_error:::', error)
      }
      this._setIsRemind() // 标记已设置提醒
    }
  }

  _judgeIsShareRemind() {
    let param = {
      actCode: Detector.interface_ActCode
    }
    api.isFinishedInfo({reqData: JSON.stringify(param)}).then(res => {
      if (res.resultCode === -1) {// 接口异常时提示弹窗
        this._showErrorTipDialog()
        return
      }
      let { code, data } = res.resultData
      if (code === '00000hby') {
        this.getConfigContents(data.weixin)
        let info = Object.assign({}, this.state.finishedInfo, {
          reminded: data.tixing,
          shared: data.weixin
        })
        this.setState({finishedInfo: info})
      }
    })
  }

  _handleJoinGame() {
    sessionStorage.setItem('yqs_handleJoinGame_flag', 1)
    window.$('canvas').css('display', 'block')
  }

  _renderStatusBtn(info) {
    console.log('this.state.finishedInfo:::', this.state.finishedInfo)
    let { shared,reminded } = this.state.finishedInfo
    // 当前时间段有活动&&(未抽奖或已抽奖但未分享)
    if (info.status === 'now' && (info.isJoin === '0' || (info.isJoin === '1' && shared === 'yes'))) {
      console.log('已开始&未参与。。。')
      sessionStorage.setItem('yqs_countdown_flag', 1)
      this.setState({statusBtnDom: (<div className="btnRemind enable"><Link to='/' className='link' clstag="jr|keycount|yqsbhby|16" onClick={this._handleJoinGame.bind(this)}>点击参与</Link></div>)})
    }
    // 当前时间段有活动&&(已抽奖1次或2次但未分享)
    if (info.status === 'now' && ((info.isJoin === '1' && shared !== 'yes') || info.isJoin === '2')) {
      console.log('已开始&已参与。。。')
      sessionStorage.setItem('yqs_countdown_flag', 2)
      this.setState({statusBtnDom: <div className="btnRemind disable" clstag="jr|keycount|yqsbhby|17">下场继续</div>})
    }
    if (info.status === 'next' && reminded !== 'yes') {
      console.log('未开始&未设置。。。')
      this.setState({statusBtnDom: <div className="btnRemind enable" onClick={this._handleRemindMe.bind(this)} clstag="jr|keycount|yqsbhby|14">提醒我</div>})
    }
    if (info.status === 'next' && reminded === 'yes') {
      console.log('未开始&已设置。。。')
      this.setState({statusBtnDom: <div className="btnRemind disable" clstag="jr|keycount|yqsbhby|15">已预约</div>})
    }
  }

  _renderMyAward(list) {
    if (list.length > 0) {
      this.setState({myAwardDom: <MyAward awardList={list}/>})
    }
  }

  _countTimeEnded(obj) {
    console.log('_countTimeEnded_倒计时已结束回调:::')
    setTimeout(() => {
      window.location.reload()
    }, 1000)
  }

  _renderActivityTime(status, timer) {
    console.log('this.state.activityTimeInfo:::', this.state.activityTimeInfo)
    this.setState({activityTimeDom: <ActivityTime curStatus={status} statusBtnDom={this.state.statusBtnDom} timerObj={timer} timeInfo={this.state.activityTimeInfo} countTimeEnded={(obj) => {this._countTimeEnded(obj)}}/>})
  }
  
  componentDidMount() {
    window.addEventListener('hashchange', (state) => {
      const href = window.location.href
      if (href.indexOf('/main') < 0) {
        this._handleGoBack()
      } else {
        window.location.reload()
      }
    })
  }

  _handleGoBack() {
    window.history.go(0)
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', (state) => {
      this._handleGoBack()
    })
  }

  _handleSeeRule() {
    window.location.href = `https://m.jr.jd.com/mjractivity/72931-2.html`
  }

  _handle2JRApp() {
    window.location.href = `https://m.jr.jd.com/spe/downloadApp/index.html?id=1192&activityid=1158`
  }

  render() {
    let { joinInfo, slideInfo, myAwardDom, activityTimeDom, shareInfo,wxShareTipDom,endedTipDom,errorTipDom } = this.state;
    let banners = this.data_source.activity.options.banners;

    // console.log('slideInfo:::', slideInfo)
    return (
      <div className="mainPage">
        {wxShareTipDom}
        {endedTipDom}
        {errorTipDom}
        <div className="rule">
          <span onClick={this._handleSeeRule.bind(this)} clstag="jr|keycount|yqsbhby|13">
            活动规则
            <span className="info" />
          </span>
        </div>
        <Slide slideInfo={slideInfo}/>
        <div className="mainContent">
          {activityTimeDom}
          {isJrApp ? (
            <div className="btnShare" onClick={this._handleShare.bind(this)} clstag="jr|keycount|yqsbhby|18">
              <p className="primary">{shareInfo.btnText || '奔走相告  邀请好友一起玩'}</p>
              {
                joinInfo.totalUser > 0 ? (
                  <p>
                    已有 <span>{kFormat(joinInfo.totalUser, ',')}</span> 人参与
                  </p>
                ) : null
              }
            </div>
          ) : (
            <div className="btnOuterShare primary" onClick={this._handle2JRApp.bind(this)} clstag="jr|keycount|yqsbhby|19">
              打开京东金融APP参与
            </div>
          )}
          {myAwardDom}
          {isJrApp && banners.show ? (
            <div className="moreActivities">
              <p className="title">更多热门活动</p>
              <div className="banners">
                <a className="big" clstag="jr|keycount|yqsbhby|20" href={banners.banner_url_1}>
                  <img src={banners.banner_image_1} alt={banners.banner_title_1} />
                </a>
                <div className="small">
                  <a className="left" clstag="jr|keycount|yqsbhby|21" href={banners.banner_url_2}>
                    <img src={banners.banner_image_2} alt={banners.banner_title_2} />
                  </a>
                  <a className="right" clstag="jr|keycount|yqsbhby|22" href={banners.banner_url_3}>
                    <img src={banners.banner_image_3} alt={banners.banner_title_3} />
                  </a>
                </div>
              </div>
              <div className="bottom_logo"></div>
            </div>
          ) : (
            <div className="QRCodeWrap">
              <p className="tip">
                马上关注京东金融服务号福利消息早知道
              </p>
              <div className="code">
                <img alt="京东金融官方服务号" src="https://m.360buyimg.com/jfe/jfs/t1/8930/4/9629/45167/5c18d94dE41d8d5de/5852b96b88cbdffa.png"/>
              </div>
              <div className="bottom_logo"></div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
